import { render, staticRenderFns } from "./NavigationLanguages.vue?vue&type=template&id=4270379c"
import script from "./NavigationLanguages.vue?vue&type=script&lang=ts"
export * from "./NavigationLanguages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports